import classnames from 'classnames';
import videojs, { VideoJsPlayer } from 'video.js';

const Component = videojs.getComponent('Component');

class UserInactiveOverlay extends Component {
  constructor(
    player: VideoJsPlayer,
    options?: videojs.ComponentOptions,
    ready?: videojs.Component.ReadyCallback
  ) {
    super(player, options, ready);
    this.updateDomContent();
  }

  buildCSSClass(className?: string) {
    return classnames(
      super.buildCSSClass(),
      className,
      'vjs-user-inactive-overlay'
    );
  }

  createEl(tag = 'div', props = {}, attributes = {}) {
    return videojs.dom.createEl(
      tag,
      {
        ...props,
        className: this.buildCSSClass(),
      },
      attributes
    );
  }

  updateDomContent() {
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(
      this.el(),
      videojs.dom.createEl('div', {
        className: 'vjs-user-inactive-overlay__top',
      })
    );
    videojs.dom.appendContent(
      this.el(),
      videojs.dom.createEl('div', {
        className: 'vjs-user-inactive-overlay__bottom',
      })
    );
  }
}

videojs.registerComponent('UserInactiveOverlay', UserInactiveOverlay);

export default UserInactiveOverlay;
